/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingSiteCategorySummary } from './BookingSiteCategorySummary';
export type BookingSite = {
    id: number;
    publicId: string;
    title: string | null;
    layout: BookingSite.layout;
    active: boolean;
    showAddress: boolean;
    requireEmailConfirmation: boolean;
    createdAt: string;
    updatedAt: string;
    categories: Array<BookingSiteCategorySummary>;
};
export namespace BookingSite {
    export enum layout {
        COMPACT = 'compact',
        EXTENDED = 'extended',
    }
}

